





 
import { useEffect, useState } from "react";
import { useParams, useNavigate ,useSearchParams} from "react-router-dom";
import { getUserByIdApi,getAllDocumentsApi } from "../../app/api";
import UserAttendance from "../profile/UserAttendanceProfile";
import UserDocuments from "../profile/UserDocuments";
import UserLeavesProfile from "../profile/UserLeavesProfile";
import TaskDetails from "../../pages/dashboard/components/TaskDetails";
import UserJourney from "../../components/Tasks/UserJourney";
 
import { useLocation } from "react-router-dom";
const IMAGE_BASE_URL = "https://demouptask.visiontrek.io/";
 
export default function UserProfile() {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
 
  const passedUser = location.state?.user;
  // const [activeTab, setActiveTab] = useState("profile");
 
 
  const [searchParams] = useSearchParams();
const tabParam = searchParams.get("tab");
  // const currentUserId = user?.id;
// const [activeTab, setActiveTab] = useState(tabParam || "profile");
const [activeTab, setActiveTab] = useState(tabParam || "profile");
 
useEffect(() => {
  setActiveTab(tabParam || "profile");
}, [tabParam]);
 
 
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
 
 
 
  useEffect(() => {
    if (passedUser) {
      setUser(passedUser);
      setLoading(false);
    } else {
      setLoading(true);
      getUserByIdApi(id)
        .then((res) => {
          if (res?.success && Array.isArray(res.data)) {
            setUser(res.data.find(u => String(u.id) === String(id)) || null);
          }
        })
        .finally(() => setLoading(false));
    }
  }, [id, passedUser]);
 
  if (loading) {
    return <div className="mt-20 text-center text-white/70">Loading…</div>;
  }
 
  // if (!user) {
  //   return <div className="mt-20 text-center text-white/70">User not found</div>;
  // }
 
 
 
  if (!user) {
    return (
      <div className="min-h-[80vh] flex items-center justify-center px-4">
        <div className="
          relative w-full max-w-xl
          p-8 rounded-3xl
          bg-gradient-to-br from-[#2d1c6a] via-[#24155a] to-[#12082f]
          text-white
          border border-white/10
          shadow-2xl
          text-center
        ">
 
          {/* Glow Effects */}
          <div className="absolute -top-10 -right-10 w-40 h-40 bg-purple-500/20 blur-3xl rounded-full" />
          <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-fuchsia-500/20 blur-3xl rounded-full" />
 
          {/* Icon */}
          <div className="text-5xl mb-4 opacity-80">🚫</div>
 
          {/* Title */}
          <h2 className="text-2xl font-semibold mb-2">
            User Not Found
          </h2>
 
          {/* Subtitle */}
          <p className="text-sm text-white/70 mb-6">
            This user may have been removed or does not exist anymore.
          </p>
 
          {/* Action Buttons */}
          <div className="flex justify-center gap-3">
            <button
              onClick={() => navigate(-1)}
              className="
                px-5 py-2 rounded-lg
                bg-white/10 hover:bg-white/20
                transition
              "
            >
              Go Back
            </button>
 
            <button
              onClick={() => navigate("/employees")}
              className="
                px-5 py-2 rounded-lg
                bg-purple-600 hover:bg-purple-500
                transition
              "
            >
              View Employees
            </button>
          </div>
        </div>
      </div>
    );
  }
 
  return (
    // <div className="max-w-7xl mx-auto px-4 py-6">
    <div className="max-w-7xl mx-auto px-4 py-6 bg-[#f3f4f8] rounded-3xl">
 
 
      {/* ===== HERO ===== */}
      <div className="
        relative rounded-3xl p-6 md:p-8 mb-10
        bg-gradient-to-br from-[#2d1c6a] via-[#24155a] to-[#12082f]
        text-white shadow-2xl md:mt-14
      ">
        <div className="flex flex-col md:flex-row md:items-center gap-6">
 
          {/* Avatar */}
          <div className="w-24 h-24 rounded-full border-4 border-white/20 overflow-hidden bg-white/10">
            {user.profile_pic ? (
              <img
                src={`${IMAGE_BASE_URL}${user.profile_pic}`}
                className="w-full h-full object-cover"
                alt="profile"
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center text-3xl">
                👤
              </div>
            )}
          </div>
 
          {/* Info */}
          <div className="flex-1">
            <h2 className="text-2xl font-semibold">
              {user.first_name} {user.last_name}
            </h2>
            <p className="text-sm opacity-80">{user.department_name}</p>
 
            <div className="flex gap-2 mt-2 text-xs">
              <span className="px-3 py-1 rounded-full bg-blue-500/20 text-blue-300">
                Role ID: {user.role_id}
              </span>
              <span className="px-3 py-1 rounded-full bg-green-500/20 text-green-300">
                {user.is_active ? "Active" : "Inactive"}
              </span>
            </div>
          </div>
 
          <button
            onClick={() => navigate(-1)}
            className="px-4 py-2 rounded-lg bg-white/10 hover:bg-white/20 text-sm"
          >
            ← Back
          </button>
        </div>
      </div>
 
 
<div className="flex gap-2 md:gap-4 mb-6 overflow-x-auto no-scrollbar p-2">
  {["profile", "attendance", "leave","task","documents", "journey"].map((tab) => (
    <button
      key={tab}
      onClick={() => setActiveTab(tab)}
      className={`
        px-6 py-2 text-sm font-semibold uppercase tracking-wide
        rounded-full transition-all duration-300
        ${
          activeTab === tab
            ? "bg-gradient-to-r from-purple-500 to-purple-700 text-white shadow-lg scale-105"
            : "bg-[#dbc4f2] text-[#5f1ea0] hover:bg-purple-200 shadow-lg"
 
        }
      `}
    >
      {tab}
    </button>
  ))}
</div>
 
      {/* ===== CONTENT ===== */}
      {activeTab === "profile" && (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
 
          <GlassCard title="Basic Information">
            <Stat label="Email" value={user.email} />
            <Stat label="Phone" value={user.phone_number} />
            <Stat label="Gender" value={user.gender} />
            <Stat label="Job Title" value={user.job_title} />
          </GlassCard>
 
          <GlassCard title="Emergency Contact">
  <Stat label=" Alternate Contact Name" value={user.alter_contact_name || "—"} />
  <Stat label=" Alternate Contact Number" value={user.alter_number || "—"} />
</GlassCard>
 
          <GlassCard title="Account">
            <Stat label="Employee ID" value={user.emp_id} />
            <Stat label="Role ID" value={user.role_id} />
            <Stat label="Joined" value={formatDate(user.joined_at)} />
            <Stat label="Date of Birth" value={user.dob || "—"} />
          </GlassCard>
 
        </div>
      )}
 
      {activeTab === "attendance" && (
        <div className="
          rounded-2xl p-5 mt-4
          bg-gradient-to-br from-[#2d1c6a] via-[#24155a] to-[#12082f]
          shadow-2xl
        ">
          <UserAttendance userId={id} />
        </div>
      )}
 
{activeTab === "leave" && (
  <div className="mt-4">
    <UserLeavesProfile Id={id} />
  </div>
)}
 
 
 
{activeTab === "task" && (
  <div
    className="
      mt-[-54px]
    "
  >
    <TaskDetails />
  </div>
)}
 
{activeTab === "documents" && (
  <div className="      mt-[-54px]
  ">
    <UserDocuments userId={id} />
  </div>
)}
 
{activeTab === "journey" && (
  <div className="mt-4 p-6 bg-gradient-to-br from-[#2d1c6a] via-[#24155a] to-[#12082f] rounded-3xl border border-white/10 shadow-2xl">
    <UserJourney userId={id} />
  </div>
)}
 
 
 
    </div>
  );
}
 
/* ===== UI HELPERS ===== */
 
function GlassCard({ title, children }) {
  return (
    <div className="
      rounded-2xl p-5
      bg-gradient-to-br from-[#2d1c6a] via-[#24155a] to-[#12082f]
        text-white backdrop-blur-xl
      border border-white/20
      text-white shadow-xl
    ">
      <h3 className="font-semibold mb-4">{title}</h3>
      <div className="space-y-3">{children}</div>
    </div>
  );
}
 
function Stat({ label, value }) {
  return (
    <div>
      <p className="text-xs opacity-60">{label}</p>
      <p className="font-medium">{value || "—"}</p>
    </div>
  );
}
 
function formatDate(date) {
  if (!date) return "—";
  return date.split(" ")[0];
}
 






// import { useEffect, useState } from "react";
// import { useParams, useNavigate ,useSearchParams} from "react-router-dom";
// import { getUserByIdApi,getAllDocumentsApi } from "../../app/api";
// import UserAttendance from "../profile/UserAttendanceProfile";
// import UserDocuments from "../profile/UserDocuments";
// import UserLeavesProfile from "../profile/UserLeavesProfile";
// import TaskDetails from "../../pages/dashboard/components/TaskDetails";

// import { useLocation } from "react-router-dom";
// const IMAGE_BASE_URL = "https://uptask.visiontrek.io";

// export default function UserProfile() {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const location = useLocation();

//   const passedUser = location.state?.user;
//   // const [activeTab, setActiveTab] = useState("profile");


//   const [searchParams] = useSearchParams();
// const tabParam = searchParams.get("tab");
//   // const currentUserId = user?.id;
// // const [activeTab, setActiveTab] = useState(tabParam || "profile");
// const [activeTab, setActiveTab] = useState(tabParam || "profile");

// useEffect(() => {
//   setActiveTab(tabParam || "profile");
// }, [tabParam]);


//   const [user, setUser] = useState(null);
//   const [loading, setLoading] = useState(true);
  


//   useEffect(() => {
//     if (passedUser) {
//       setUser(passedUser);
//       setLoading(false);
//     } else {
//       setLoading(true);
//       getUserByIdApi(id)
//         .then((res) => {
//           if (res?.success && Array.isArray(res.data)) {
//             setUser(res.data.find(u => String(u.id) === String(id)) || null);
//           }
//         })
//         .finally(() => setLoading(false));
//     }
//   }, [id, passedUser]);

//   if (loading) {
//     return <div className="mt-20 text-center text-white/70">Loading…</div>;
//   }

//   // if (!user) {
//   //   return <div className="mt-20 text-center text-white/70">User not found</div>;
//   // }



//   if (!user) {
//     return (
//       <div className="min-h-[80vh] flex items-center justify-center px-4">
//         <div className="
//           relative w-full max-w-xl
//           p-8 rounded-3xl
//           bg-gradient-to-br from-[#2d1c6a] via-[#24155a] to-[#12082f]
//           text-white
//           border border-white/10
//           shadow-2xl
//           text-center
//         ">
  
//           {/* Glow Effects */}
//           <div className="absolute -top-10 -right-10 w-40 h-40 bg-purple-500/20 blur-3xl rounded-full" />
//           <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-fuchsia-500/20 blur-3xl rounded-full" />
  
//           {/* Icon */}
//           <div className="text-5xl mb-4 opacity-80">🚫</div>
  
//           {/* Title */}
//           <h2 className="text-2xl font-semibold mb-2">
//             User Not Found
//           </h2>
  
//           {/* Subtitle */}
//           <p className="text-sm text-white/70 mb-6">
//             This user may have been removed or does not exist anymore.
//           </p>
  
//           {/* Action Buttons */}
//           <div className="flex justify-center gap-3">
//             <button
//               onClick={() => navigate(-1)}
//               className="
//                 px-5 py-2 rounded-lg
//                 bg-white/10 hover:bg-white/20
//                 transition
//               "
//             >
//               Go Back
//             </button>
  
//             <button
//               onClick={() => navigate("/employees")}
//               className="
//                 px-5 py-2 rounded-lg
//                 bg-purple-600 hover:bg-purple-500
//                 transition
//               "
//             >
//               View Employees
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     // <div className="max-w-7xl mx-auto px-4 py-6">
//     <div className="max-w-7xl mx-auto px-4 py-6 bg-[#f3f4f8] rounded-3xl">


//       {/* ===== HERO ===== */}
//       <div className="
//         relative rounded-3xl p-6 md:p-8 mb-10
//         bg-gradient-to-br from-[#2d1c6a] via-[#24155a] to-[#12082f]
//         text-white shadow-2xl md:mt-14
//       ">
//         <div className="flex flex-col md:flex-row md:items-center gap-6">

//           {/* Avatar */}
//           <div className="w-24 h-24 rounded-full border-4 border-white/20 overflow-hidden bg-white/10">
//             {user.profile_pic ? (
//               <img
//                 src={`${IMAGE_BASE_URL}${user.profile_pic}`}
//                 className="w-full h-full object-cover"
//                 alt="profile"
//               />
//             ) : (
//               <div className="w-full h-full flex items-center justify-center text-3xl">
//                 👤
//               </div>
//             )}
//           </div>

//           {/* Info */}
//           <div className="flex-1">
//             <h2 className="text-2xl font-semibold">
//               {user.first_name} {user.last_name}
//             </h2>
//             <p className="text-sm opacity-80">{user.department_name}</p>

//             <div className="flex gap-2 mt-2 text-xs">
//               <span className="px-3 py-1 rounded-full bg-blue-500/20 text-blue-300">
//                 Role ID: {user.role_id}
//               </span>
//               <span className="px-3 py-1 rounded-full bg-green-500/20 text-green-300">
//                 {user.is_active ? "Active" : "Inactive"}
//               </span>
//             </div>
//           </div>

//           <button
//             onClick={() => navigate(-1)}
//             className="px-4 py-2 rounded-lg bg-white/10 hover:bg-white/20 text-sm"
//           >
//             ← Back
//           </button>
//         </div>
//       </div>

//       {/* ===== TABS ===== */}
//       {/* <div className="flex gap-3 mb-6">
//         {["profile", "attendance", "leave"].map(tab => (
//           <button
//             key={tab}
//             onClick={() => setActiveTab(tab)}
//             className={`px-5 py-2 rounded-full text-sm transition
//               ${
//                 activeTab === tab
//                   ? "bg-purple-600 text-white shadow"
//                   : "bg-gray-300 text-white hover:bg-purple-600 shadow-lg"
//               }`}
//           >
//             {tab.toUpperCase()}
//           </button>
//         ))}
//       </div> */}

// <div className="flex gap-4 mb-6">
//   {["profile", "attendance", "leave","task","documents"].map((tab) => (
//     <button
//       key={tab}
//       onClick={() => setActiveTab(tab)}
//       className={`
//         px-6 py-2 text-sm font-semibold uppercase tracking-wide
//         rounded-full transition-all duration-300
//         ${
//           activeTab === tab
//             ? "bg-gradient-to-r from-purple-500 to-purple-700 text-white shadow-lg scale-105"
//             : "bg-[#dbc4f2] text-[#5f1ea0] hover:bg-purple-200 shadow-lg"

//         }
//       `}
//     >
//       {tab}
//     </button>
//   ))}
// </div>

//       {/* ===== CONTENT ===== */}
//       {activeTab === "profile" && (
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

//           <GlassCard title="Basic Information">
//             <Stat label="Email" value={user.email} />
//             <Stat label="Phone" value={user.phone_number} />
//             <Stat label="Gender" value={user.gender} />
//             <Stat label="Job Title" value={user.job_title} />
//           </GlassCard>

//           <GlassCard title="Emergency Contact">
//   <Stat label=" Alternate Contact Name" value={user.alter_contact_name || "—"} />
//   <Stat label=" Alternate Contact Number" value={user.alter_number || "—"} />
// </GlassCard>

//           <GlassCard title="Account">
//             <Stat label="Employee ID" value={user.emp_id} />
//             <Stat label="Role ID" value={user.role_id} />
//             <Stat label="Joined" value={formatDate(user.joined_at)} />
//             <Stat label="Date of Birth" value={user.dob || "—"} />
//           </GlassCard>

//         </div>
//       )}

//       {activeTab === "attendance" && (
//         <div className="
//           rounded-2xl p-5 mt-4
//           bg-gradient-to-br from-[#2d1c6a] via-[#24155a] to-[#12082f]
//           shadow-2xl
//         ">
//           <UserAttendance userId={id} />
//         </div>
//       )}

// {activeTab === "leave" && (
//   <div className="mt-4">
//     <UserLeavesProfile Id={id} />
//   </div>
// )}



// {activeTab === "task" && (
//   <div
//     className="
//       mt-[-54px]
//     "
//   >
//     <TaskDetails />
//   </div>
// )}

// {activeTab === "documents" && (
//   <div className="      mt-[-54px]
//   ">
//     <UserDocuments userId={id} />
//   </div>
// )}



//     </div>
//   );
// }

// /* ===== UI HELPERS ===== */

// function GlassCard({ title, children }) {
//   return (
//     <div className="
//       rounded-2xl p-5
//       bg-gradient-to-br from-[#2d1c6a] via-[#24155a] to-[#12082f]
//         text-white backdrop-blur-xl
//       border border-white/20
//       text-white shadow-xl
//     ">
//       <h3 className="font-semibold mb-4">{title}</h3>
//       <div className="space-y-3">{children}</div>
//     </div>
//   );
// }

// function Stat({ label, value }) {
//   return (
//     <div>
//       <p className="text-xs opacity-60">{label}</p>
//       <p className="font-medium">{value || "—"}</p>
//     </div>
//   );
// }

// function formatDate(date) {
//   if (!date) return "—";
//   return date.split(" ")[0];
// }









